module.exports = __webpack_public_path__ + "media/press/bla1-51c2a7c4.png";